export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/bg/federico-beccari-1331ba97560cc13103d379a8843ad1dc.jpg";